import React from 'react';
import { useRouter } from 'next/router';
import * as S from './DesktopHeaderRightAction.styles';
import { DesktopHeaderNewAdBtn } from './DesktopHeaderNewAdBtn';
import { useAuthStore } from '@/store/useAuthStore';
import { useHasUnreadMessages } from '@/utils/pubnub/useHasUnreadMessages';
import { useDesktopCatalogueStore } from '@/store/useDesktopCatalogueStore';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { ROUTES } from '@/constants/routes';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { getUrlBasedOnAuth } from '@/utils/helpers';
import { ProfileMenu } from '@/components/ProfileMenu';
import { usePageType } from '@/hooks/usePageType';
import { PageType } from '@/hooks/usePageType/usePageType.types';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const DesktopHeaderRightAction = () => {
  const { pathname, asPath } = useRouter();
  const [isAuthLoaded, isAuthenticated] = useAuthStore(state => [
    state.isAuthLoaded,
    state.isAuthenticated,
  ]);
  const hasUnreadMessages = useHasUnreadMessages();
  const pageType = usePageType();

  const [isDesktopCatalogueOpen, toggleDesktopCatalogue] =
    useDesktopCatalogueStore(state => [
      state.isDesktopCatalogueOpen,
      state.toggleDesktopCatalogue,
    ]);
  const [isNavOpen, toggleNav] = useNavMenuStore(state => [
    state.isNavOpen,
    state.toggleNav,
  ]);

  const isBookmarksPage = pathname === ROUTES.bookmarks;
  const isMessagesPage = pathname === ROUTES.messages;
  const messagesHref = isAuthLoaded
    ? getUrlBasedOnAuth(isAuthenticated, ROUTES.messages, asPath)
    : ROUTES.messages;
  const hasNewAdBtn =
    ![PageType.NewAd, PageType.EditAd].includes(pageType) &&
    pathname !== ROUTES.businessLanding &&
    pathname !== ROUTES.shops;

  function onClick() {
    if (isNavOpen) toggleNav();
    if (isDesktopCatalogueOpen) toggleDesktopCatalogue();
  }

  return (
    <S.DesktopHeaderItemsBox
      data-testid={CommonTestIds.desktopHeader.rightAction}
    >
      <S.DesktopHeaderRightActionLink
        dataTestId={CommonTestIds.desktopHeader.bookmarksLink}
        href={ROUTES.bookmarks}
        onClick={onClick}
      >
        <S.DesktopHeaderRightActionIcon
          $height={18}
          $filename="favorites-outlined.svg"
          $isActive={isBookmarksPage}
        />
      </S.DesktopHeaderRightActionLink>
      <S.DesktopHeaderRightActionLink
        dataTestId={CommonTestIds.desktopHeader.messagesLink}
        href={messagesHref}
        onClick={onClick}
      >
        <S.DesktopHeaderRightActionIcon
          $height={24}
          $filename="messages-outlined.svg"
          $isActive={isMessagesPage}
        />
        {hasUnreadMessages && (
          <S.UnreadMessagesIcon data-testid="desktop-header-unread-messages-indicator" />
        )}
      </S.DesktopHeaderRightActionLink>
      {hasNewAdBtn && <DesktopHeaderNewAdBtn onClick={onClick} />}
      {isAuthLoaded ? (
        <ProfileMenu />
      ) : (
        <S.ProfileMenuSkeleton data-testid="desktop-header-profile-menu-skeleton">
          <SkeletonLoader borderRadius={14} width="100%" height="44px" />
        </S.ProfileMenuSkeleton>
      )}
    </S.DesktopHeaderItemsBox>
  );
};
